import request from "../utils/request";

export const sysLogin = (params) => {
  return request({
    url: "/sys/login",
    method: "post",
    data: params,
  });
};

export const sysLogin1 = (params) => {
  return request({
    url: "/sys/login",
    method: "get",
    params,
  });
};

// 境外左上角
export const getFourPartData = (params) => {
  return request({
    url: "/app/odata/querySacAnalysis",
    method: "get",
    params,
  });
};
// 境外左下角 其他风险利率
export const jwzxj = (params) => {
  return request({
    url: "/app/odata/queryExchangeRageDif",
    method: "get",
    params,
  });
};

// 境外table
export const jwtable = (params) => {
  return request({
    url: "/app/odata/queryRiskIndicators",
    method: "get",
    params,
  });
};

// 境外三个echart 饼状图
export const jwEchart = (params) => {
  return request({
    url: "/app/odata/getIndicatorProportion",
    method: "get",
    params,
  });
};

// 国内地图
export const getChinaMap = () => {};
// 世界地图
export const getWorldMap = () => {
  return request({
    url: "/app/odata/queryOrganizationMark",
    method: "get",
  });
};

// 获取天气
export const getWeather = () => {
  return request({
    url: "/app/odata/queryWeather",
    method: "get",
  });
};

// 境内、境外、光明国际饼状图
export const getIndicatorProportion = (params) => {
  return request({
    url: "/app/GroupRisk/getIndicatorProportion",
    method: "get",
    params,
  });
};

// 查询子风险
export const queryChilidIndicatorDetails = (params) => {
  return request({
    url: "/app/odata/queryChilidIndicatorDetails",
    method: "get",
    params,
  });
};
// 查询总部风险概览头部EBITDA
export const queryTopEBITDA = (params) => {
  return request({
    url: "/app/GroupRisk/queryTopEBITDA",
    method: "get",
    params,
  });
};
// 查询境外EBITDA
export const queryOverSeasEBITDA = (params) => {
  return request({
    url: "/app/odata/queryOverSeasEBITDA",
    method: "get",
    params,
  });
};

// 查询境内风险kri以及最大天数，type=1,按板块划分，type=2,按公司划分
export const getRiskIndicators = (params) => {
  return request({
    url: "/app/domesticRisk/getRiskIndicators",
    method: "get",
    params,
  });
};
// 根据三级公司或板块查询四级公司,参数传三级公司名，或板块名都可以
export const getChildrenList = (params) => {
  return request({
    url: "/app/domesticRisk/getChildrenList",
    method: "get",
    params,
  });
};
// 通过四级公司名，查五级公司，key为相同的监控口径名
export const getRiskDetailsByCompany4 = (params) => {
  return request({
    url: "/app/domesticRisk/getRiskDetailsByCompany4",
    method: "get",
    params,
  });
};
// 通过五级公司名查询风险指标
export const getRiskIndicatorsByArea = (params) => {
  return request({
    url: "/app/domesticRisk/getRiskIndicatorsByArea",
    method: "get",
    params,
  });
};

export const getUserInfo = (params) => {
  return request({
    url: "/app/AuthorizationInfo/getAuthInfo",
    method: "get",
    params,
  });
};
// 获取部门首页信息
export const queryDepartmentRiskIndicators = (params) => {
  return request({
    url: "/app/odata/queryDepartmentRiskIndicators",
    method: "get",
    params,
  });
};
// 境外左下角 其他风险利率
export const queryBwList = () => {
  return request({
    url: "/app/odata/queryBwList",
    method: "get",
  });
};
//查询合同列表
export const queryContractList = (params) => {
  return request({
    url: "/app/contract/queryContractList",
    method: "post",
    data: params,
  });
};
//查询融资性贸易判别合同列表
export const queryContractConfirmList = (params) => {
  return request({
    url: "/app/contract/queryContractConfirmList",
    method: "post",
    data: params,
  });
};
//合同确认
export const contractConfirm = (params) => {
  return request({
    url: "/app/contract/contractConfirm",
    method: "post",
    data: params,
  });
};
// 外部市场价格指数
export const queryExternalMarketPriceIndex = () => {
  return request({
    url: "/app/domesticRisk/queryExternalMarketPriceIndex",
    method: "get",
  });
};
// 获取走马灯
export const getQueryEconomicIndex = () => {
  return request({
    url: "/app/odata/queryEconomicIndex",
    method: "get",
  });
};

//导出kri detail excel
export const exportRiskInfo = (params) => {
  return request({
    url: "/app/odata/exportRiskInfo",
    method: "post",
    data: params,
  });
};

// secret存入sesstion
export const getUserAESinfo = () => {
  return request({
    url: "/app/AuthorizationInfo/getUserAESinfo",
    method: "get",
  });
};

//光明合同列表
export const getAllContractDetailsOrdered = (params) => {
  return request({
    url: "/app/contract/getAllContractDetailsOrdered",
    method: "post",
    data: params,
  });
};

// 光明国际合同上下游上传
export const contractUpload = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request({
      url: '/app/contract/contractUpload',
      method: 'post',
      data: formData,
  });
};
// 光明国际合同上下游上传
export const contractUploadMultipe = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request({
      url: '/app/contract/contractUploadMultipe',
      method: 'post',
      data: formData,
  });
};

// 光明关联关系查询
export const getRel = (params) => {
  const formData = new FormData();
  return request({
      url: '/app/contract/getRel',
      method: 'get',
      params
  });
};

//光明国际合同上下游详情
export const queryGmgjContract = (params) => {
  return request({
    url: "/app/contract/queryGmgjContract",
    method: "post",
    data: params,
  });
};
//光明合同添加
export const addContractDetail = (params) => {
  return request({
    url: "/app/contract/addContractDetail",
    method: "post",
    data: params,
  });
};

//光明合同确认
export const gmContractConfirm = (params) => {
  return request({
    url: "/app/contract/gmContractConfirm",
    method: "post",
    data: params,
  });
};
// 更新pdf和是否疑似
export const contractPdfurlAndSuspected = (params) => {
  return request({
    url: "/app/contract/contractPdfurlAndSuspected",
    method: "post",
    data: params,
  });
};
// 任务进度查询
export const getTaskProgress = (params) => {
  return request({
      url: '/app/contract/getTaskProgress',
      method: 'get',
      params
  });
};